import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchAlerts, dismissDuplicateAlert } from '../api/alerts';
import { useCandidateProfile } from '../../store';
import { queryKeys } from './queryKeys';
import type { Alerts } from '../types';

export const useAlerts = () => {
  const {
    paths: { getAlertsPath },
  } = useCandidateProfile();

  return useQuery({
    queryKey: queryKeys.alerts,
    queryFn: () => fetchAlerts(getAlertsPath),
    select: (data) => data.alerts,
    retry: false,
    staleTime: 60000,
    refetchOnReconnect: false,
  });
};

export const useDismissDuplicateAlert = () => {
  const {
    paths: { ignoreDuplicatePath },
  } = useCandidateProfile();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return await dismissDuplicateAlert(ignoreDuplicatePath);
    },
    onSuccess: () => {
      // Update the alerts cache to remove the duplicate alert
      queryClient.setQueryData(
        queryKeys.alerts,
        (oldData: { alerts: Alerts } | undefined) => {
          if (!oldData) {
            return oldData;
          }
          return {
            ...oldData,
            alerts: {
              ...oldData.alerts,
              duplicate: null,
            },
          };
        }
      );
    },
  });
};
